import config from 'config'
import {
  AssessorDashboard
} from 'containers/pages'
import React from 'react'
import { get } from 'lodash'
import activity from './activity'
import aj from './aj'
import rp from './rp'
import wwc from './wwc'
import { Restricted } from 'containers/misc'

const urlPrefix = `${config.publicPath}/assessor`


export default [
  {
    path: `${urlPrefix}`,
    component: props => (
      <Restricted>
        <AssessorDashboard
          params={get(props, 'match.params', {})}
          {...props}
        />
      </Restricted>
    ),
    routes: [
      ...activity,
      ...aj,
      ...rp,
      ...wwc
    ]
  }
]
